import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSparkleSelectedEmojiSecondary from './svgs/SparkleSelectedEmojiSecondary.js';
import SvgSparkleSelectedEmoji from './svgs/SparkleSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var sparkleSelectedEmoji = (props => useIcon(SvgSparkleSelectedEmoji, SvgSparkleSelectedEmojiSecondary, props));

export { sparkleSelectedEmoji as default };
